<template>
<span>
  <a-icon :type="iconType" theme="filled" @click.stop="CollectNow(id)" :style="{color:ori_collect?lightColor:'#e0e0e0',fontSize:size+'px'}"/>
</span>
</template>

<script>
export default {
  name: "",
  data() {
    return {
        
    };
  },
  mounted(){
      
  },
  props: {
    id: {
      type: String,
      default: () => {
        return "";
      },
    },
    iconType: {
      type: String,
      default: () => {
        return "heart";
      },
    },
    lightColor:{
      type: String,
      default:()=>{
        return '#ff3c00';
      }
    },
    size: {
      type: Number,
      default: () => {
        return 16;
      },
    },
    
  },
  methods: {
	   CollectNow(id){
            let method = "put"
            let showmsg = "已收藏"
            if(this.ori_collect){
                method = "delete"
                showmsg = "已取消收藏"
            }
            this.$axios({url:`${window.commonApi.INFOPLUS_URL}/me/preference/FavoriteApps/${id}`,method})
			            .then((res) => {
				          if (res.data.errno == 0) {
					          let items = res.data.entities[0].FavoriteApps;
					          this.$store.commit('favoriteReset',items)
					          this.$message.success(showmsg);
				          }else{
					          this.$message.error(res.data.error);
                  }
				        }).catch(function (error) {
					          this.$message.error(error);
			      });
        },

  },
  computed: {
      ori_collect(){
          return this.$store.getters.getFavorites.indexOf(this.id)>-1;
      }
  },
};
</script>


// WEBPACK FOOTER //
// src/components/todoCenter/collect.vue